// extracted by mini-css-extract-plugin
export default {"modalContent":"permitModal_modalContent__76qSt","permitText":"permitModal_permitText__nZklr","permitOkButton":"permitModal_permitOkButton__jeO9g"};